import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import DateInterval from '../../_common/DateInterval'
import Currency from '../../_common/Currency'
import PresentableDate from '../../_common/PresentableDate';
import ButtonWithChevron from "../../_minha-central/ButtonWithChevron"

const Course = props => {

    const {
        id,
        imgSrc,
        title,
        //  shadow,
        //overlayColor,
        description,
        location,
        type,
        startDate,
        endDate,
        workload,
        value,
        presentableDate,
        showButton,
        buttonLabel,
        contentType,
    } = props

    return (

        <div id={'curso-' + id} className={'nrt-course-default'}
             onClick={() => props.onButtonClick(id, contentType)}
        >

            {
                !!type &&
                <div className='type'>{type}</div>
            }

            <div onClick={() => props.onButtonClick(id, contentType)}
                 className={'course-image lazy'}
                 data-src={imgSrc}

                 style={{
                     backgroundColor: `var(--primary-color-dark)`
                 }}>


            </div>

            <div className="course-header">

                {
                    ((!!startDate || !!endDate) && !presentableDate) &&
                    <div className="course-date">
                        <DateInterval startDate={startDate} endDate={endDate}/>
                    </div>
                }

                {
                    ((!!startDate || !!endDate) && presentableDate) &&
                    <div className="course-date">
                        <PresentableDate startDate={startDate} endDate={endDate}/>
                    </div>
                }

                <h3>{title}</h3>

                {
                    !!workload &&
                    <div className="course-workload">
                          <img src={require('./../../../assets/images/clock-icon.svg')}/>
                        <span style={{flex:.8}}>
                        Carga Horária: {workload}h
                    </span>
                    </div>
                }

                {
                    !!location &&
                    <div className='course-location'>
                        <img src={require('./../../../assets/images/location-icon.svg')}/>
                        <span style={{flex:.8}}>
                        {location}
                    </span>
                    </div>

                }
            </div>

            {
                !!description &&
                <p>{description}</p>
            }

            {
                !!value &&
                <div className='price'><Currency value={value }/></div>
            }


            {
                showButton &&
                <div className="course-buttons">
                    <ButtonWithChevron
                        buttonLabel={buttonLabel}
                        onClick={() => props.onButtonClick(id, contentType)}/>
                </div>
            }
        </div>
    )
}

Course.propTypes = {
    id: PropTypes.string,
    imgSrc: PropTypes.string,
    title: PropTypes.string,
    shadow: PropTypes.string,
    overlayColor: PropTypes.string,
    description: PropTypes.any,
    location: PropTypes.string,
    type: PropTypes.string,
    startDate: PropTypes.Date,
    endDate: PropTypes.Date,
    workload: PropTypes.number,
    value: PropTypes.number,
    presentableDate: PropTypes.bool,
    onButtonClick: PropTypes.func,
    buttonLabel: PropTypes.string,
    showButton: PropTypes.bool
}

Course.defaultProps = {
    shadow: false,
    overlayColor: 'none',
    presentableDate: false,
    buttonLabel: 'Mais Info.',
    showButton: true
}

export default Course



// WEBPACK FOOTER //
// ./src/components/_home/Course/index.js